export default __webpack_public_path__ + "static/media/GE.97cd064e.svg";